import Lenis from '@studio-freight/lenis'

const useLenisScroll = () => {
  window.lenis = new Lenis()

  function raf(time) {
    window.lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)
}

export default useLenisScroll
